import { useNuxtApp } from "nuxt/app";
import mediaTypes from "~/constants/mediaTypes";

export const getIcon = (mt: String): Array<String> => {
  return mediaTypes.filter((obj) => obj.value === mt)[0]?.icon ?? [""];
};

export const getPrettyMediaType = (mt: String): string => {
  const { $i18n } = useNuxtApp(); // access injected i18n
  // @ts-ignore
  const t = $i18n.global.t;

  return t(mediaTypes.filter((obj) => obj.value === mt)[0]?.name) ?? "";
};

export const getStatusValue = (status: string): string => {
  const { $i18n } = useNuxtApp(); // access injected i18n
  // @ts-ignore
  const t = $i18n.global.t;

  const statusMap: Record<
    "submitted" | "added" | "processing" | "not_available",
    string
  > = {
    // submitted -> requested
    // added -> added
    submitted: t("manage.mentionsAndPublications.submitted"),
    added: t("manage.mentionsAndPublications.added"),
    processing: t("manage.mentionsAndPublications.processing"),
    not_available: t("manage.mentionsAndPublications.notAvailable"),
  };

  return (
    statusMap[status as keyof typeof statusMap] ||
    t("manage.mentionsAndPublications.unknownStatus")
  );
};
